import React, { useEffect, useState } from 'react';
import { TOKEN, USER_TYPE, USER_ID } from '../../api/axios';
import AttendanceTable from '../common/AttendanceTable';
import { getSupervisors } from '../../services/supervisors';
import { getDriverAttendanceBySupervisor, getDrivers } from '../../services/drivers';

const DriverAttendance = () => {
  const [supervisors, setSupervisors] = useState([]);
  const [selSupervisor, setSelSupervisor] = useState(0);
  const [drivers, setDrivers] = useState([]);
  const [selDriver, setSelDriver] = useState(0);
  const [attendance, setAttendance] = useState([]);
  const [userId, setUserId] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [frmDate, setFrmDate] = useState(() => {
    return new Date().toISOString().split('T')[0];
  });

  const [toDate, setToDate] = useState(() => {
    return new Date().toISOString().split('T')[0];
  });

  const [form, setForm] = useState({
    username: '',
    email: '',
    phone: '',
    emp_code: '',
    password: '',
  });

  useEffect(() => {
    const currentUser = sessionStorage.getItem(USER_TYPE);
    const isAdminUser = currentUser.toLowerCase() === 'admin';
    const userId = sessionStorage.getItem(USER_ID);
    setIsAdmin(isAdminUser);
    setUserId(userId);
    //  fetchDrivers();
    if (isAdminUser) {
      fetchSupervisors();
    } else {
      fetchDrivers(userId);
    }
  }, []);

  const fetchSupervisors = async () => {
    // Example
    try {
      const res = await getSupervisors();
      let options = [];
      res.forEach(spv => {
        // if (isAdminUser) {
        options.push(spv);
        //  }
      });
      setSupervisors(options);
      // setSelSupervisor(options[0].user.id);
    } catch (err) {
      console.error(err);
      setSupervisors([]); // fallback to avoid undefined
    }
  };

  const handleSupervisorChange = async e => {
    setDrivers([]);
    setFrmDate([]);
    setToDate([]);
    const selectedId = e.target.value;
    if (!selectedId || selectedId === '' || selectedId === 0) {
      console.log('No valid supervisor selected yet');
      return;
    }
    setSelSupervisor(selectedId);
    console.log(selSupervisor);
    if (selectedId) {
      fetchDrivers(selectedId);
    } else {
      setDrivers([]);
    }
  };

  const fetchDrivers = async supervisorId => {
    setDrivers([]);
    try {
      if (!supervisorId) return;

      const res = await getDrivers(supervisorId);
      setDrivers(res || []);
    } catch (error) {
      console.error('Failed to fetch drivers', error);
      setDrivers([]); // fallback to empty list
    }
  };

  const fetchDriversAttendance = async () => {
    try {
      const res = await getDriverAttendanceBySupervisor(
        isAdmin ? selSupervisor : null,
        frmDate,
        toDate,
        selDriver
      );
      setAttendance(res || []);
    } catch (err) {
      console.error('Failed to fetch drivers', err);
    }
  };

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h4>ATTENDANCE REPORT</h4>
        </div>
      </div>
      <div className="row mb-3">
        {isAdmin && (
          <div className="col-md-3">
            <label>Supervisor</label>
            <select className="form-select" value={selSupervisor} onChange={handleSupervisorChange}>
              <option value="" disabled>
                Select
              </option>
              {supervisors.map(s => (
                <option key={s.user.id} value={s.user.id}>
                  {s.user.username}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="col-md-2">
          <label>Driver</label>
          <select
            className="form-select"
            value={selDriver}
            onChange={e => setSelDriver(e.target.value)}
          >
            <option value={0}>Select</option>
            {drivers.map(d => (
              <option key={d.user.id} value={d.user.id}>
                {d.user.username}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-2">
          <label>From Date</label>
          <input
            type="date"
            className="form-control"
            value={frmDate}
            onChange={e => setFrmDate(e.target.value)}
          />
        </div>

        <div className="col-md-2">
          <label>To Date</label>
          <input
            type="date"
            className="form-control"
            value={toDate}
            onChange={e => setToDate(e.target.value)}
          />
        </div>

        <div className="col-md-2 d-flex align-items-end">
          <button className="btn btn-warning w-100" onClick={fetchDriversAttendance}>
            VIEW
          </button>
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h4></h4>
        </div>
      </div>
      <AttendanceTable attendanceData={attendance} />
    </div>
  );
};

export default DriverAttendance;
